import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Renderer2, ElementRef, Input, Inject } from '@angular/core';

@Component({
    selector: 'finder-css-loader',
    template: ''
})
export class CssLoaderComponent implements OnInit {
    @Input() src: string;

    constructor(
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
    ) { }

    ngOnInit() {
        if (this.src) {
            this.loadCss(this.src);
        }
    }

    loadCss(src: string): void {
        const cssLink = this.renderer.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = src;
        this.renderer.appendChild(this.document.head, cssLink);
    }

}
